module.exports = __webpack_public_path__ + "static/media/rock6-01.6c7f0cbd.svg";